export default __webpack_public_path__ + "static/media/rating_2.e4d5ac09.svg";